
import Vue from 'vue'
import { Textbox, DropDownSelect } from '@/components/formGroups'

export default Vue.extend({
   name: 'CreditCardPaymentForm',
   props: {
      value: Object as () => ICreditCard,
      showErrors: { type: Boolean, default: false },
      showTitle: { type: Boolean, default: true },
   },
   data() {
      return {}
   },
   computed: {
      monthOptions() {
         return [...Array(12).keys()]
            .map(n => (n + 1).toString())
            .map(n => ({ name: n.length === 1 ? `0${n}` : n, value: n }))
      },
      yearOptions() {
         const currentYear = new Date().getFullYear()
         return [...Array(20).keys()]
            .map(n => (n + currentYear).toString())
            .map(n => ({ name: n, value: n }))
      },
   },
   methods: {
      raiseEvent(eventName: string) {
         this.$emit(eventName, this.value)
      },
   },
   components: {
      Textbox,
      DropDownSelect,
   },
})
